import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userConstants } from '../../constants';
import { alertActions, organizationActions, recycleBinActions } from '../../actions';

const useTrashBinHook = ({
  organization_id
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [archivedCards, setArchivedCards] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const { deleted_content_groups } = useSelector((s) => s.content_group);

  const addCardToSelection = (data) => {
    setSelectedItems(prevState => [...prevState.filter((i) => i.id !== data.id), data])
  }

  const removeCardToSelection = (data) => {
    setSelectAll(false);
    setSelectedItems(prevState => [...prevState.filter((i) => i.id !== data.id)]);
  }

  const handleSelectAll =() =>{
    setSelectAll(true);
  }

  const handleUnselectAll =() =>{
    setSelectAll(false);
    setSelectedItems([])
  }

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteAllModal, setShowDeleteAllModal] = useState(false);
  const handleDelete = useCallback((allOverride = null, refresh = false)=> {
    // delete all items
    // pass selectAll and selectedItems ids to axios
    const callback =()=>  {
      setSelectAll(false);
      setSelectedItems([]);
      setShowDeleteModal(false);
      setShowDeleteAllModal(false);

      if(refresh){
        refreshBin();
      }
    }

    const onError = (response) => {
      dispatch(alertActions.error(response.data.error));
      setShowDeleteModal(false);
      setShowDeleteAllModal(false);
    }

    const ids = selectedItems?.map((item) => item.id)
    const all = allOverride !== null ? allOverride : selectAll
    const params = {
      all: all,
      organization_id,
      ids,
      callback,
      onError
    }

    dispatch(recycleBinActions.destroyDeletedContentGroups(params))
    
  }, [selectAll, selectedItems, organization_id]);

  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const handleRestore = useCallback((allOverride = null, refresh = false)=> {

    const callback = () => {
      setSelectAll(false);
      setSelectedItems([]);
  
      // remove restored cards to list
      setShowRestoreModal(false);

      if(refresh){
        refreshBin();
      }
    }

    const ids = selectedItems?.map((item) => item.id)
    const all = allOverride !== null ? allOverride : selectAll
    const params = {
      all: all,
      organization_id,
      ids,
      callback
    }

    dispatch(recycleBinActions.restoreDeletedContentGroups(params))
  }, [selectAll, selectedItems, organization_id]);

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    loadBin(page + 1);
  }

  const loadBin = (page) => {
    let callback = (res) => {
      setHasMore(res.data.data.has_next_page);
      if(page === 1){
        setArchivedCards((prevState) => res.data.data.content_groups);
      } else {
        setArchivedCards((prevState) => [...prevState, ...res.data.data.content_groups]);
      }
      
    }

    dispatch(recycleBinActions.getDeletedContentGroups({organization_id, page, callback}));
  }

  const refreshBin = () => {
    setPage(1);
    loadBin(1);
  }

  const handleResetCache = () => {
    const onBefore = () => {
      dispatch({ type: userConstants.ORGANIZATION_LOADING });
    }

    const onFinal = () => {
      dispatch({ type: userConstants.UPDATE_ORGANIZATION });
    }

    const onSuccess = (response) => {
       dispatch(alertActions.success(userConstants.ORGANIZATION_RESET_CACHE_SUCCESS));
    }

    const onError = (response) => {
      dispatch(alertActions.error(userConstants.ORGANIZATION_RESET_CACHE_FAILED));
    }

    const onFailure = (response) => {
      dispatch(alertActions.error(userConstants.ORGANIZATION_RESET_CACHE_FAILED));
    }

    const params = {
      id: organization_id,
      onFinal,
      onBefore,
      onSuccess,
      onError,
      onFailure
    }
    dispatch(organizationActions.resetCacheOrganization(params));
  }

  useEffect(() => {
    if(selectAll){
      setSelectedItems(deleted_content_groups)
    }else
    return () => {
      
    };
  }, [selectAll, deleted_content_groups]);
  

  return {
    selectedItems, setSelectedItems,
    selectAll,setSelectAll,
    archivedCards, setArchivedCards,

    addCardToSelection,
    removeCardToSelection,
    handleSelectAll,
    handleUnselectAll,

    showDeleteModal, setShowDeleteModal,
    showDeleteAllModal, setShowDeleteAllModal,
    handleDelete,

    showRestoreModal, setShowRestoreModal,
    handleRestore,

    handleResetCache,

    page,
    setPage,
    loadBin,
    loadMore,
    hasMore,
    refreshBin
  }

};

export default useTrashBinHook;